import { Link } from 'react-router-dom';

const footerNavColumns = [
  {
    title: '热门栏目',
    links: [
      { label: '每日大赛', path: '/category/daily-contest' },
      { label: '网红塌房', path: '/category/celebrity-scandal' },
      { label: '博主反差', path: '/category/blogger-contrast' },
      { label: '热门事件', path: '/category/trending' },
    ],
  },
  {
    title: '快速导航',
    links: [
      { label: '关于我们', path: '/about' },
      { label: '最新爆料', path: '/category/trending' },
      { label: '网站地图', path: '/sitemap' },
    ],
  },
  {
    title: '友情链接',
    links: [
      { label: '51吃瓜网站', path: '/category/daily-contest' },
      { label: '五一吃瓜网站', path: '/category/celebrity-scandal' },
      { label: '吃瓜视频网站', path: '/category/blogger-contrast' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100">
      {/* Decorative blocks */}
      <div className="relative overflow-hidden">
        <div className="absolute -left-6 top-0 w-24 h-24 bg-secondary-200/60 rounded-2xl rotate-12" />
        <div className="absolute -right-8 bottom-0 w-32 h-32 bg-primary-100/50 rounded-3xl -rotate-12" />
        <div className="absolute right-1/4 top-1/2 w-16 h-16 bg-accent-200/40 rounded-xl rotate-45" />

        {/* Main content */}
        <div className="relative max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-18">
          <div className="bg-background-50 rounded-2xl p-8 md:p-12">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
              {/* Brand block */}
              <div className="md:col-span-1">
                <Link to="/" className="inline-block">
                  <span className="font-heading text-2xl font-bold text-primary-500">
                    吃瓜网站
                  </span>
                </Link>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                  吃瓜网站首页入口直达，整合51吃瓜网站、五一吃瓜网站核心栏目，覆盖网红塌房、博主反差视频与网络热门事件最新爆料，每日大赛不停更。
                </p>
                <div className="flex items-center gap-3 mt-5">
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 hover:bg-primary-100 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微博">
                    <i className="ri-weibo-line" />
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 hover:bg-primary-100 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微信">
                    <i className="ri-wechat-line" />
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 hover:bg-primary-100 hover:text-primary-500 transition-colors cursor-pointer" aria-label="RSS">
                    <i className="ri-rss-line" />
                  </a>
                </div>
              </div>

              {/* Nav columns */}
              {footerNavColumns.map((column) => (
                <div key={column.title} className="md:col-span-1">
                  <h4 className="text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
                    {column.title}
                  </h4>
                  <ul className="flex flex-col gap-2.5">
                    {column.links.map((link) => (
                      <li key={link.label}>
                        <Link
                          to={link.path}
                          className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Copyright bar */}
      <div className="border-t border-background-200/70">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            <span>&copy; 2026 吃瓜网站 All Rights Reserved.</span>
            <span className="hidden sm:inline text-foreground-300">|</span>
            <a href="#" className="hover:text-primary-500 transition-colors">隐私政策</a>
            <span className="text-foreground-300">|</span>
            <a href="#" className="hover:text-primary-500 transition-colors">用户协议</a>
            <span className="text-foreground-300">|</span>
            <a href="#" className="hover:text-primary-500 transition-colors">免责声明</a>
          </div>
          <div className="flex items-center gap-1 text-xs text-foreground-500">
            <span>本站内容仅供娱乐参考</span>
            <span className="text-foreground-300">·</span>
            <span>吃瓜网站首页入口直达</span>
          </div>
        </div>
      </div>
    </footer>
  );
}